import React from 'react';

// Single shared "headline number" card used at the top of every Evidence tab
// (SLA Metrics, Segments, and any future tab). Previously each tab defined
// its own version inline — Segments had none at all, which is why it felt
// thinner than SLA Metrics. Centralising it means a style tweak here updates
// every tab at once.

export default function StatCard({ icon: Icon, label, value, detail, color = '#0747A6' }) {
  return (
    <div className="evidence-metric-card">
      <div className="evidence-metric-card-header">
        <div className="evidence-metric-icon" style={{ background: `${color}14`, color }}>
          <Icon size={17} />
        </div>
        <div className="evidence-metric-label">{label}</div>
      </div>
      <div className="evidence-metric-value">{value}</div>
      {detail ? <div className="evidence-metric-detail">{detail}</div> : null}
    </div>
  );
}
